import * as PropTypes from 'prop-types';
import * as React from 'react';

const Option = ({ category }) =>
  <option value={category.id}>{category.displayName}</option>;

Option.propTypes = {
  category: PropTypes.object.isRequired,
};

export default Option;



// WEBPACK FOOTER //
// ./javascripts/components/category_select/option.jsx